import * as React from 'react'
import { Link } from 'react-router-dom';


interface ISystemLink {
    className?: string,
    to: any,
    children?: any,
    title?: string,
    handleClick?(): void
}

export const SystemLink = (props: ISystemLink) => {
    return (
        props.to == null || props.to == undefined || props.to == '' ?
            <a onClick={props.handleClick} className={props.className} title={props.title}>{props.children}</a> :
            <Link onClick={props.handleClick} to={props.to} className={props.className} title={props.title}>{props.children}</Link>

    )
}
